import { Navigate, Route, Routes } from "react-router";
import LoginWrapper from "../pages/auth/login/LoginWrapper";
import ForgetPasswordWrapper from "../pages/auth/forget-password/ForgetPasswordWrapper";

const PublicRoutes = () => {
  // useEffect(() => {}, []);
  return (
    <Routes>
      <Route path="/auth/login" element={<LoginWrapper />} />
      <Route path="/auth/forgot-password" element={<ForgetPasswordWrapper />} />
      <Route
        path="/auth/forgot-password/:token"
        element={<ForgetPasswordWrapper />}
      />
      <Route path="*" element={<Navigate to={"/auth/login"} replace />} />
    </Routes>
  );
};

export default PublicRoutes;
